export const MAX_PROFILE_RELATED_ARTISTS = 5

export const MESSAGE_GROUP_THRESHOLD_MINUTES = 2

// Minimum time spent buffering until we show visual indicators (loading spinners, etc)
// Intended to avoid flickering buffer states and avoid showing anything at all if the buffer is short & barely noticeable
export const MIN_BUFFERING_DELAY_MS = 1000

// Maximum time to wait for an audio request to start loading before trying next mirror
// Matches the longest cascading timeout phase (30s)
export const AUDIO_LOAD_TIMEOUT_MS = 30000
export const TEMPORARY_PASSWORD = 'TemporaryPassword'

export const AUDIO_MATCHING_REWARDS_MULTIPLIER = 1
